const UAT_HOSTNAME = "uat.zielfintech.com";
const UAT_MEASUREMENT_ID = "G-N8DVDDTXFL";

const PRODUCTION_HOSTNAME = "platform.zielfintech.com";
const PRODUCTION_MEASUREMENT_ID = "G-NX6326TPXQ";

let initialized = false;
let lastTrackedModule = null;

const MODULE_NAMES = {
  Home: "Home",
  Reports: "Daily Reports",
  MIS: "OPS MIS",
  Collexa: "Collexa",
  PDD: "PDD Module",
  PreOnboarding: "Pre-Onboarding",
  ITInventory: "Asset Inventory",
  DigitalJourney: "Digital Journey",
  ZohoMIS: "Dashboard",
  "Bank Verification": "Bank Verification",
  Adminusers: "Admin",
  Admin: "Admin",
  MainHrForm: "FORM",
};

const getAnalyticsConfig = () => {
  if (
    typeof window === "undefined" ||
    typeof document === "undefined"
  ) {
    return {
      enabled: false,
      measurementId: null,
    };
  }

  if (window.location.hostname === PRODUCTION_HOSTNAME) {
    return {
      enabled: true,
      measurementId: PRODUCTION_MEASUREMENT_ID,
    };
  }

  if (window.location.hostname === UAT_HOSTNAME) {
    return {
      enabled: true,
      measurementId: UAT_MEASUREMENT_ID,
    };
  }

  return {
    enabled: false,
    measurementId: null,
  };
};

export const initAnalytics = () => {
  const config = getAnalyticsConfig();

  if (!config.enabled) {
    return false;
  }

  if (!config.measurementId) {
    console.warn(
      "[Analytics] Measurement ID is not configured."
    );

    return false;
  }

  if (initialized) {
    return true;
  }

  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  const script = document.createElement("script");

  script.async = true;

  script.src =
    "https://www.googletagmanager.com/gtag/js?id=" +
    encodeURIComponent(config.measurementId);

  document.head.appendChild(script);

  window.gtag("js", new Date());

  window.gtag("config", config.measurementId, {
    send_page_view: false,
  });

  initialized = true;

  console.log(
    "[Analytics] Google Analytics initialized."
  );

  return true;
};

export const trackEvent = (
  eventName,
  parameters = {}
) => {
  const config = getAnalyticsConfig();

  if (!config.enabled) {
    return;
  }

  if (!window.gtag) {
    return;
  }

  window.gtag("event", eventName, parameters);
};

export const getModuleName = (routeName) => {
  if (!routeName) {
    return "Unknown";
  }

  return MODULE_NAMES[routeName] || routeName;
};

export const trackModuleView = (routeName) => {
  const module = getModuleName(routeName);

  if (module === lastTrackedModule) {
    return;
  }

  lastTrackedModule = module;

  trackEvent("module_view", {
    module,
  });
};

export const trackFeatureAction = (
  routeName,
  feature,
  action,
  additionalParameters = {}
) => {
  const module = getModuleName(routeName);

  trackEvent("feature_used", {
    module,
    feature,
    action,
    ...additionalParameters,
  });
};

export const trackExternalNavigation = (
  routeName,
  feature,
  destination
) => {
  const module = getModuleName(routeName);

  trackEvent("external_navigation", {
    module,
    feature,
    destination,
  });
};